import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { KeyboardEvent, useContext, useState } from 'react';

import { CHATBV_GA4_EVENTS } from 'components/ChatBV/constants';
import { ChatContext } from 'components/ChatBV/context';

// eslint-disable-next-line no-unused-vars
export const useChatForm = (onSendMessage: (message: string) => void) => {
  const { trackEventGA4 } = useContext(AppConfig);
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(e.target.value);
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && inputValue.trim()) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const context = useContext(ChatContext);
  if (context === undefined) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  const handleSendMessage = () => {
    if (inputValue.trim()) {
      trackEventGA4({
        event_name: CHATBV_GA4_EVENTS.name,
        type: CHATBV_GA4_EVENTS.message.type,
        subtype: CHATBV_GA4_EVENTS.message.subTypes.message_submit,
      });
      context.sendMessage(inputValue);
      onSendMessage(inputValue);
      setInputValue('');
    }
  };

  return { inputValue, handleInputChange, handleKeyPress, handleSendMessage };
};
